export const VIEW_DETAILS_PAGE = "VIEW_DETAILS_PAGE";
export const HIDE_DETAILS_PAGE = "HIDE_DETAILS_PAGE";
export const VIEW_Complete_Earning_TwoDiamond_DETAILS_PAGE =
  "VIEW_Complete_Earning_TwoDiamond_DETAILS_PAGE";
export const VIEW_Complete_Earning_TwoDiamond_DETAILS_PAGE_Hide =
  "VIEW_Complete_Earning_TwoDiamond_DETAILS_PAGE_Hide";
export const VIEW_EDIT_SHOW = "VIEW_EDIT_SHOW";
export const VIEW_EDIT_HIDE = "VIEW_EDIT_HIDE";
